import { purchaseOrdersTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  milestoneConfig: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const purchaseOrders = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case purchaseOrdersTypes.GET_PURCHASE_ORDERS_DEFINITIONS:
      return {
        ...state,
        isLoading: true,
      };
    case purchaseOrdersTypes.GET_PURCHASE_ORDERS_SUCCESS:
      return {
        ...state,
        data: action.payload.purchaseOrdersData,
        CountItems: action.payload.CountItems,
        isLoading: false,
      };

    case purchaseOrdersTypes.GET_PURCHASE_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case purchaseOrdersTypes.GET_MILESTONESCONFIG_PO_SUCCESSS:
        return{
          ...state,
          milestoneConfig: action.payload
        }
  
    case purchaseOrdersTypes.GET_MILESTONESCONFIG_PO_FAIL:
          return{
            ...state,
            error: action.payload,
          }

    default:
      return state;
  }
};

export default purchaseOrders;
